export function EmptySection({ children }) {
  return (
    <p className="px-4 pt-1 pb-3 text-sm text-gray-500">
      {children}
    </p>
  );
}


export function Attribute({ label, children, icon: Icon, wide = false }) {
  const gridColumn = wide ? `span ${wide} / span ${wide}` : "";

  return (
    <div style={{ gridColumn }}>
      <span className="mb-1 flex items-center gap-2 text-sm font-semibold  text-gray-500">
        {!!Icon && <Icon aria-hidden="true" size={15} />}
        {label}
      </span>
      <p className="break-words text-sm text-gray-800">{children}</p>
    </div>
  );
}
